import { BadgeKind } from 'src/components/Badge';
import { MenuType } from 'src/models/menu';

export interface MenuItem {
    name: string;
    text: string;
    url: string | null;
    activators?: string[];
    type?: MenuType;
    level?: 2;
    badge?: BadgeKind;
    items?: Array<MenuItem>;
}

export interface MenuItemWithSubItems extends MenuItem {
    items: Array<MenuItem>;
    badge?: BadgeKind;
}

export interface MenuItemWithUrl extends MenuItem {
    url: string;
}

export const isActiveItem = (menuItemName: string, pageName: string, activatorNames: string[] = []): boolean => {
    return menuItemName === pageName || (activatorNames && activatorNames.includes(pageName));
};

export const hasActiveChild = (menuList: MenuItem[], pageName: string): boolean => {
    return menuList.some((menuItem) => isActiveItem(menuItem.name, pageName, menuItem.activators));
};
